import { useContextStore } from '~/stores/useContextStore';
import { useProfileStore } from '~/stores/useProfileStore';
export default defineNuxtRouteMiddleware(async (to, from) => {
  const context = useContextStore();

  const auth = to.meta.auth != null ? to.meta.auth : true;

  if (!auth) return;

  if (!context.isLoggedIn) {
    return navigateTo('/signin');
  }
});
